import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { SidebarComponent } from 'src/app/core/components/sidebar/sidebar.component'
import Swal from 'sweetalert2';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.scss']
})
export class PersonalInfoComponent implements OnInit {
  // @ViewChild(SidebarComponent) child: SidebarComponent;
  msgfinal: string;
  msg: string;

  firstName: any;
  ErrorMsgone: boolean = false;
  middlename;
  lastName: any;
  ErrorMsgtwo: boolean = false;
  email: any;
  ErrorMsgthree: boolean = false;
  pcaddress: any;
  ErrorMsgfour: boolean = false;
  phno: any;
  ErrorMsgfive: boolean = false;
  ciprnumber: any;
  ErrorMsgsix: boolean = false;
  role = "";
  ErrorMsgseven: boolean = false;
  city: any;
  ErrorMsgeight: boolean = false;
  ErrorMsgfifteen: boolean = false;
  ErrorMsgcompanyName: boolean = false;
  country: any;
  ErrorMsgnine: boolean = false;
  postalcode: any;
  ErrorMsgten: boolean = false;
  Province: any;
  ErrorMsgeleven: boolean = false;
  altaddress: any;
  ErrorMsgtwel: boolean = false;
  dashboardList: any;
  error: any;
  languages = [];
  Salutation = [];
  salutation: any;
  personalinfo: any;
  agencyName: any;
  workPhone: any;
  alternativeAddressProvince: any;
  alternativeCompeteAddress: any;
  alternativeAddressCountry: any;
  alternativeAddressCity: any;
  primaryAddressProvince: any;
  primaryAddressCity: any;
  primaryAddressCountry: any;
  primaryCompleteAddress: any;
  positionTitle: any;
  website: any;
  selectedSalutation: any;
  selectedLanguage = [];
  loading: boolean;
  dropdownSettingsLanguages = {};
  dropdownSettingsTags = {};
  languagesArray = [];
  id: any;
  emailAddress = [];
  firstBlock: boolean = false;
  isprimarySelected: boolean = false;
  addoption: boolean = false;
  optedOut: boolean = false;
  Invalid: boolean = false;
  isPersonalInfo: boolean = false;
  isCompleted: boolean = false;
  optedOutNo: any;
  InvalidNo: any;
  error6: any;
  error5: any;
  error3: any;
  tagsList = [];
  tagsArray = [];
  tags = [];
  agencyMgaId: any;
  userId: any;
  leadStatus: any
  type: any
  errorCIPR = "";
  allLanguages = [];
  leadTypes = [];
  province = [];

  onAlternativeDefault: boolean = false;
  altAddress: boolean = true;
  altprovince: boolean = true;
  altcity: boolean = true;
  altCountry: boolean = true;
  altPostal: boolean = true;
  checkFlag: boolean = false;
  checkFlag1: boolean = false;
  ErrorMsgTwelve: boolean = false;
  error1 =null;
  error2=null;
  isdisabledPI: boolean = false;
  dropdownSettingsPLicensed = {};
  dropdownSettingsProvinces = {};
  PLicensedArray = [];
  allPLicensedData = [];
  allProvicesList = [];
  errormob= "";
  showbtn: any;
  saveproceedmodal: boolean=false;
  companyName: any;
  isCompanySignup: boolean=false;
  checkComapnyShowStatus: any;
  myTravelLinkRequest:any;
  errorpostalcode=null;
  errorpostalcodeAlternate=null;
  ErrorMsgprovince: boolean = false;
  ErrorMsgeleven1: boolean = false;
  mgaIdNo: boolean = false;
  wfgCode: any;
  isSinRequesteddata: [];
  requestSINHistory: any;
  hideLastRequestedDateSIN: boolean=false;
  lastRequestedDateSIN: any;
  lastRequestedDateSINBy: any;
  constructor(public user: UserService, public router: Router) {
  }

  ngOnInit(): void {
    this.getDashboard();
    this.onAgency();
    this.getLeadTags();
    this.getLeadInfo();
    // this.dropdownSettingsPLicensed={
    //   singleSelection: false, 
    //   text:"Select Languages",
    //   selectAllText:'Select All Languages',
    //   unSelectAllText:'UnSelect All Languages',
    //   enableSearchFilter: true,
    //   classes:"myclass inputField",
    //   badgeShowLimit: 15,
    //   disabled: false
    // };
    // this.dropdownSettingsLanguages = { 
    //   singleSelection: false, 
    //   text:"Select Languages",
    //   selectAllText:'Select All Languages',
    //   unSelectAllText:'UnSelect All Languages',
    //   enableSearchFilter: true,
    //   classes:"myclass inputField",
    //   badgeShowLimit: 15,
    //   disabled: this.isdisabledLang

    // };
    this.dropdownSettingsTags = {
      singleSelection: false,
      text: "Select Tags",
      selectAllText: 'Select All Tags',
      unSelectAllText: 'UnSelect All Tags',
      enableSearchFilter: true,
      classes: "myclass inputField",
      badgeShowLimit: 20,
      disabled: this.isdisabledPI

    };


  }
  onItemSelectLanguages(item: any) {
  }
  OnItemDeSelectLanguages(item: any) {
  }
  onSelectAllLanguages(items: any) {
  }
  onDeSelectAllLanguages(items: any) {
  }
  onItemSelectTags(item: any) {
  }
  OnItemDeSelectTags(item: any) {
  }
  onSelectAllTags(items: any) {

  }
  onDeSelectAllTags(items: any) {
  }
  onItemSelectPL(item: any) {
    // console.log(item);
    //console.log(this.selectedItems);
  }
  OnItemDeSelectPL(item: any) {
      }
  onSelectAllPL(items: any) {
    // console.log(items);
  }
  onDeSelectAllPL(items: any) {
    //  console.log(items);
    this.PLicensedArray = [];
  }
  onItemSelectProvinces(item: any) {
    //  (item)
      }
      OnItemDeSelectProvinces(item: any) {
      //    (item)
      }
      onSelectAllProvinces(items: any) {
    //    (id)
      }
      onDeSelectAllProvinces(items: any) {
      //    (items)
      this.PLicensedArray=[];
      }

  proceed() {
    if(this.hideLastRequestedDateSIN==true){
      this.addSin();
    }
else{
    this.user.addMember(this.firstName,
        this.middlename,
        this.lastName,
        //this.personalinfo.selectedLanguage,
        this.languages,
        this.allProvicesList,
        // this.tags,
        this.personalinfo.primaryAddressCity,
        this.personalinfo.primaryAddressCountry,
        this.personalinfo.primaryAddressPostalCode,
        this.personalinfo.primaryAddressProvince,
        this.personalinfo.primaryCompleteAddress,
        this.personalinfo.workPhone,
        this.personalinfo.workPhoneExtension,
        this.personalinfo.alternativeAddressCity,
        this.personalinfo.alternativeAddressCountry,
        this.personalinfo.alternativeAddressPostalCode,
        this.personalinfo.alternativeAddressProvince,
        this.personalinfo.alternativeCompeteAddress,
        this.personalinfo.ciprnumber,
        this.emailAddress,
        this.personalinfo.mobileNumber,
        this.positionTitle,
        this.personalinfo.leadId,
        this.personalinfo.salutation,
        this.agencyMgaId,
        this.userId,
        this.leadStatus,
        this.type,
        this.personalinfo.website,
        this.isCompanySignup,
        this.companyName,
        this.myTravelLinkRequest,this.agencyCompNameId,this.sinNumber,this.wfgCode
      )
        .pipe(first())
        .subscribe(
          data => {            
            if (data.success == true) {
              this.mgaIdNo=false
              // Swal.fire('', data.data, 'success')
              let templocaldata = JSON.parse(sessionStorage.getItem('currentUserBroker'));
              if (templocaldata != undefined) {
                templocaldata.userProfile.firstName = this.personalinfo.firstName;
                templocaldata.userProfile.lastName = this.personalinfo.lastName;
                templocaldata.userProfile.middleName = this.personalinfo.middleName;
                templocaldata.userProfile.phoneNumber = this.personalinfo.mobileNumber;
                sessionStorage.setItem('currentUserBroker', JSON.stringify(templocaldata));
              }
              // 
              setTimeout(() => {
                if(this.type == 'Office Admin Staff'){
                  this.router.navigate(['/dashboard/dashboard-mga'])
                }
                else{
                  this.router.navigate(['/dashboard/upload-documents'])
                } 
                Swal.fire('', data.data, 'success')
                  .then(() => {
                    window.location.reload();
                  });
              }, 150);
       

            } else {
              Swal.fire('', data.data, 'error')

            }

          }, error => {
            this.PLicensedArray = [];
            this.languagesArray = [];
            this.languages = [];
            this.allProvicesList = [];
            this.getDashboard();

            if (error == "Bad Request") {
              Swal.fire("Bad Request please try again!")
            }
            else {
              //debugger
              if(this.agencyMgaId==null){
                this.mgaIdNo=true
                // Swal.fire("An Agency/ MGA is not associated with your account. Please wait for the Compliance Team to confirm your account.")            
              }
              else{
                this.mgaIdNo=false
                Swal.fire("Something went wrong. Please check and try again!")
              }
             

            }
            //  }
          }, () => { });
        }

  }
  checkValid() {
    this.checkPhone()
    if(this.personalinfo.mobileNumber !==null && this.personalinfo.mobileNumber !==""){
      this.checkPhonemobile(this.personalinfo.mobileNumber)
    }
    //
    var flag = true
    var errormsg = [];
    if (this.languagesArray != null) {
      for (let i = 0; i < this.languagesArray.length; i++) {
        this.languages.push(this.languagesArray[i].id)
      }
    }
    if (this.PLicensedArray != null) {

      if (this.PLicensedArray.length > 0) {
        for (let i = 0; i < this.PLicensedArray.length; i++) {
          var obj = {};
          let temp = this.personalinfo.leadProvinces.filter(itm => itm.provinces.provinceName +'-'+ itm.provinces.provinceCode == this.PLicensedArray[i].itemName)
          if (temp.length > 0) {
            obj["id"] = this.PLicensedArray[i].id;
          } else {
            obj["id"] = 0;
          }
          obj["provinces"] = this.PLicensedArray[i].id;
          this.allProvicesList.push(obj);
        }
      }
       //console.log(JSON.stringify(this.allProvicesList))
    }
    if (this.tagsArray != null) {
      for (let i = 0; i < this.tagsArray.length; i++) {
        this.tags.push(this.tagsArray[i].id)
      }
    }
      
    if (this.error1 != null){
       flag = false; errormsg.push('Work Phone')
    }
    if (this.error2 != null){
       flag = false; errormsg.push('Mobile Number')
    }
    
   
    if(this.personalinfo.primaryAddressCity !==null){this.personalinfo.primaryAddressCity=this.personalinfo.primaryAddressCity.replace(/(^[,\s]+)|([,\s]+$)/g, '');}
    if(this.personalinfo.primaryCompleteAddress !==null){this.personalinfo.primaryCompleteAddress=this.personalinfo.primaryCompleteAddress.replace(/(^[,\s]+)|([,\s]+$)/g, '');}
    if(this.personalinfo.primaryAddressCity !==null){this.personalinfo.primaryAddressCity=this.personalinfo.primaryAddressCity.trim()}
    if(this.personalinfo.primaryCompleteAddress !==null){this.personalinfo.primaryCompleteAddress=this.personalinfo.primaryCompleteAddress.trim() }
    if(this.personalinfo.primaryAddressCity !==null){this.personalinfo.primaryAddressCity=titleCase1(this.personalinfo.primaryAddressCity) }
      if(this.personalinfo.primaryCompleteAddress !==null){this.personalinfo.primaryCompleteAddress=titleCase1(this.personalinfo.primaryCompleteAddress) }
    if(this.personalinfo.alternativeAddressCity !==null){
    this.personalinfo.alternativeAddressCity=this.personalinfo.alternativeAddressCity.replace(/(^[,\s]+)|([,\s]+$)/g, '');}
    if(this.personalinfo.alternativeCompeteAddress !==null){this.personalinfo.alternativeCompeteAddress=this.personalinfo.alternativeCompeteAddress.replace(/(^[,\s]+)|([,\s]+$)/g, '');}
    if(this.personalinfo.alternativeAddressCity !==null){this.personalinfo.alternativeAddressCity=this.personalinfo.alternativeAddressCity.trim()}
    if(this.personalinfo.alternativeCompeteAddress !==null){this.personalinfo.alternativeCompeteAddress=this.personalinfo.alternativeCompeteAddress.trim()}
    if(this.personalinfo.alternativeAddressCity !==null){this.personalinfo.alternativeAddressCity=titleCase1(this.personalinfo.alternativeAddressCity) }
    if(this.personalinfo.alternativeCompeteAddress !==null){this.personalinfo.alternativeCompeteAddress=titleCase1(this.personalinfo.alternativeCompeteAddress) }
  
  
  
  function capitalizeFirstLetter(string) {
     try{
      return string[0].toUpperCase() + string.slice(1).toLowerCase();
    }
    catch{

    }
     
  }
          function titleCase(string) {
           
            try{
              return string.split(" ").map(x => capitalizeFirstLetter(x)).join(" ");
            }
            catch{
        
            }
        }
          function titleCase1(string) {
            
            try{
              return string.split(',').map(x => capitalizeFirstLetter(x)).join(",");
            }
            catch{
        
            }
        }
        if(this.personalinfo.primaryAddressCity !==null){this.personalinfo.primaryAddressCity=titleCase(this.personalinfo.primaryAddressCity)}
        if(this.personalinfo.primaryCompleteAddress !==null){this.personalinfo.primaryCompleteAddress=titleCase(this.personalinfo.primaryCompleteAddress)}
        if(this.personalinfo.alternativeAddressCity){
        this.personalinfo.alternativeAddressCity=titleCase(this.personalinfo.alternativeAddressCity)}
        if(this.personalinfo.alternativeCompeteAddress!==null){this.personalinfo.alternativeCompeteAddress=titleCase(this.personalinfo.alternativeCompeteAddress)
        }
        function makeUpperCaseAfterCommas(str) {
          return str.replace(/,\s*([a-z])/g, function(d,e) { return ", "+e.toUpperCase() });
      }
      if(this.personalinfo.primaryAddressCity !==null){this.personalinfo.primaryAddressCity=makeUpperCaseAfterCommas(this.personalinfo.primaryAddressCity)}
        if(this.personalinfo.primaryCompleteAddress !==null){this.personalinfo.primaryCompleteAddress=makeUpperCaseAfterCommas(this.personalinfo.primaryCompleteAddress)}
        if(this.personalinfo.alternativeAddressCity){
        this.personalinfo.alternativeAddressCity=makeUpperCaseAfterCommas(this.personalinfo.alternativeAddressCity)}
        if(this.personalinfo.alternativeCompeteAddress!==null){
        this.personalinfo.alternativeCompeteAddress=makeUpperCaseAfterCommas(this.personalinfo.alternativeCompeteAddress)
        }
      
    if (!this.firstName || this.firstName.length <= 0) { this.ErrorMsgone = true; flag = false; errormsg.push("'First Name'") }
    if (!this.lastName || this.lastName.length <= 0) { this.ErrorMsgtwo = true; flag = false; errormsg.push("'Last Name'") }
    if (!this.personalinfo.primaryCompleteAddress || this.personalinfo.primaryCompleteAddress.length <= 0) { this.ErrorMsgfour = true; flag = false; errormsg.push("'Primary Complete Address'") }
    if (!this.personalinfo.primaryAddressPostalCode || this.personalinfo.primaryAddressPostalCode.length <= 0) { this.errorpostalcode = true; flag = false; errormsg.push("'Primary Address Postal Code'") }
    if(!this.myTravelLinkRequest || this.myTravelLinkRequest.length <= 0){this.ErrorMsgnine = true;  flag=false; errormsg.push("'Business to Consumer (B2C) link (select one)'")}
    if(this.myTravelLinkRequest == 'Website') 
    
    {
      if(this.personalinfo.website==null || this.personalinfo.website==""){
      this.ErrorMsgfifteen = true;  flag=false; errormsg.push("'Website URL'")
    }
  }
    if (!this.personalinfo.primaryAddressCity || this.personalinfo.primaryAddressCity.length <= 0) { this.ErrorMsgeight = true; flag = false; errormsg.push("'Primary Address City'") }
    if (!this.personalinfo.primaryAddressProvince || this.personalinfo.primaryAddressProvince.length <= 0) {this.ErrorMsgprovince= true; flag = false; errormsg.push("'Primary Address Province'") }
    
    if(this.personalinfo.primaryAddressPostalCode.length>5){
      this.personalinfo.primaryAddressPostalCode=this.personalinfo.primaryAddressPostalCode.replace(/\s/g, "")
      // this.primaryAddressPostalCode=this.primaryAddressPostalCode.replace(/.{3}$/,' $&');
    }
    if(!this.personalinfo.primaryAddressPostalCode || (this.personalinfo.primaryAddressPostalCode.length <=0 || this.personalinfo.primaryAddressPostalCode.length <6)){this.ErrorMsgeleven = true;  flag=false;} 
    else{
      this.personalinfo.primaryAddressPostalCode=this.personalinfo.primaryAddressPostalCode.replace(/.{3}$/,' $&');
    }
    var re = /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i;
 
    if (!re.test(this.personalinfo.primaryAddressPostalCode)) {
      this.ErrorMsgeleven = true;  flag=false;
    }
    if(this.ErrorMsgeleven == true){
      errormsg.push("'Primary Postal Code'")
    }
if(this.personalinfo.alternativeAddressPostalCode !==null){
    if(this.personalinfo.alternativeAddressPostalCode.length>5){
      this.personalinfo.alternativeAddressPostalCode=this.personalinfo.alternativeAddressPostalCode.replace(/\s/g, "")
      // this.primaryAddressPostalCode=this.primaryAddressPostalCode.replace(/.{3}$/,' $&');
    }
    if( (this.personalinfo.alternativeAddressPostalCode.length >0 && this.personalinfo.alternativeAddressPostalCode.length <6)){this.ErrorMsgeleven1 = true;  flag=false;} 
    else{
      this.personalinfo.alternativeAddressPostalCode=this.personalinfo.alternativeAddressPostalCode.replace(/.{3}$/,' $&');
    }
    if(this.personalinfo.alternativeAddressPostalCode.length >0){
    var re = /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i;
 
    if (!re.test(this.personalinfo.alternativeAddressPostalCode)) {
      this.ErrorMsgeleven1 = true;  flag=false;
    }
    if(this.ErrorMsgeleven1 == true){
      errormsg.push("'Alternative Postal Code'")
    }
    }
    else{
      this.errorpostalcodeAlternate=null
    }
  }

    // if (!this.personalinfo.primaryAddressPostalCode || (this.personalinfo.primaryAddressPostalCode.length <=0 || this.personalinfo.primaryAddressPostalCode.length <7)) { this.ErrorMsgeleven = true; flag = false; errormsg.push("'Primary Postal Code'") }
  
    if (!this.emailAddress || this.emailAddress.length <= 0) { this.ErrorMsgTwelve = true; flag = false; errormsg.push("'Email Address'") }

    if (!this.personalinfo.workPhone || this.personalinfo.workPhone.length <= 0) { this.ErrorMsgfive = true; flag = false; errormsg.push("'Work Phone'") }
    //  if(!this.type || this.type.length <= 0){this.ErrorMsgthree = true;  flag=false; errormsg.push('Type')}  
    if(this.isCompanySignup==true){
      if (!this.companyName || this.companyName.length <= 0) { this.ErrorMsgcompanyName = true; flag = false; errormsg.push("'Your Company'") }
      // if (this.confirmBNMatch || !this.BNNumber || !this.confirmBNNumber) { flag = false; errormsg.push("'Business Number'")}
      this.sinNumber=null
      this.confirmSINNumber=null
    }
    if(this.isCompanySignup !==true){
      this.agencyCompName=null
    }
    if(this.hideLastRequestedDateSIN==true ||this.checkComapnyShowStatus == 'BROKER' || this.checkComapnyShowStatus == 'Broker'){
    if(this.hideLastRequestedDateSIN==true || (this.isCompanySignup !==true && (this.type == 'Broker' || this.type == 'Broker-RIBO' || (this.type === 'Office Sales Staff' && this.personalinfo.agencyMgaName!=='Travelance (MGA)') ||(this.type === 'MGA Rep' && this.personalinfo.agencyMgaName!=='Travelance (MGA)') ))){
    if (!this.sinNumber || this.sinNumber == "") { flag = false; errormsg.push("'SIN'")}
    if (!this.confirmSINNumber || this.confirmSINNumber == "") { flag = false; errormsg.push("'Confirm SIN'")}
    if(this.sinNumber && this.confirmSINNumber){
      if(this.confirmSINMatch || this.confirmSINMatchlength){flag = false; return}
    }
    }
  }
  if(this.personalinfo.agencyMgaName=="World Financial Group (MGA)"){
    if (!this.wfgCode || this.wfgCode == "") { flag = false; errormsg.push("'WFG Code'")}
  }
    if (flag == true) {
      this.personalinfo.primaryAddressCountry = "Canada";
      this.personalinfo.alternativeAddressCountry = "Canada";
      this.saveproceedmodal = true
      // this.user.addMember(this.firstName,
      //   this.middlename,
      //   this.lastName,
      //   //this.personalinfo.selectedLanguage,
      //   this.languages,
      //   this.allProvicesList,
      //   // this.tags,
      //   this.personalinfo.primaryAddressCity,
      //   this.personalinfo.primaryAddressCountry,
      //   this.personalinfo.primaryAddressPostalCode,
      //   this.personalinfo.primaryAddressProvince,
      //   this.personalinfo.primaryCompleteAddress,
      //   this.personalinfo.workPhone,
      //   this.personalinfo.workPhoneExtension,
      //   this.personalinfo.alternativeAddressCity,
      //   this.personalinfo.alternativeAddressCountry,
      //   this.personalinfo.alternativeAddressPostalCode,
      //   this.personalinfo.alternativeAddressProvince,
      //   this.personalinfo.alternativeCompeteAddress,
      //   this.personalinfo.ciprnumber,
      //   this.emailAddress,
      //   this.personalinfo.mobileNumber,
      //   this.positionTitle,
      //   this.personalinfo.leadId,
      //   this.personalinfo.salutation,
      //   this.agencyMgaId,
      //   this.userId,
      //   this.leadStatus,
      //   this.type,
      //   this.personalinfo.website,
      //   this.isCompanySignup,
      //   this.companyName,
      //   this.myTravelLinkRequest
      // )
      //   .pipe(first())
      //   .subscribe(
      //     data => {
      //       if (data.success == true) {
                
      //         // Swal.fire('', data.data, 'success')
      //         let templocaldata = JSON.parse(sessionStorage.getItem('currentUserBroker'));
      //         if (templocaldata != undefined) {
      //           templocaldata.userProfile.firstName = this.personalinfo.firstName;
      //           templocaldata.userProfile.lastName = this.personalinfo.lastName;
      //           templocaldata.userProfile.middleName = this.personalinfo.middleName;
      //           templocaldata.userProfile.phoneNumber = this.personalinfo.mobileNumber;
      //           sessionStorage.setItem('currentUserBroker', JSON.stringify(templocaldata));
      //         }
      //         // 
      //         setTimeout(() => {
      //           if(this.type == 'Office Admin Staff'){
      //             this.router.navigate(['/dashboard/dashboard-mga'])
      //           }
      //           else{
      //             this.router.navigate(['/dashboard/upload-documents'])
      //           } 
      //           Swal.fire('', data.data, 'success')
      //             .then(() => {
      //               window.location.reload();
      //             });
      //         }, 150);
       

      //       } else {
      //         Swal.fire('', data.data, 'error')

      //       }

      //     }, error => {
      //       this.PLicensedArray = [];
      //       this.languagesArray = [];
      //       this.languages = [];
      //       this.allProvicesList = [];
      //       this.getDashboard();

      //       if (error == "Bad Request") {
      //         Swal.fire("Bad Request please try again!")
      //       }
      //       else {
      //         Swal.fire("Something went wrong. Please check and try again!")

      //       }
      //       //  }
      //     }, () => { });

    }
    else {
      this.msg = errormsg.toString();
this.msgfinal = this.msg.replace(/,/g, '<br />');  // Use regex to replace all commas
Swal.fire({
  title: "",
  html: "Please complete the following mandatory field(s):<br>" + this.msgfinal,  // Use 'html' instead of plain text
  icon: 'warning'
});
    }


  }

  getDashboard() {
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
          

           this.dashboardList = data.data;
           for (let i = 0; i < data.data.allLanguages.length; i++) {
            this.allLanguages.push({ "id": data.data.allLanguages[i], "itemName": data.data.allLanguages[i] });
          }
           
          this.Salutation = data.data.salutation;
          this.personalinfo = data.data.leads;
          this.salutation = data.data.leads.salutation;
          this.province = data.data.provinces
          this.wfgCode=this.personalinfo.wfgCode
          this.requestedSINHistory(this.personalinfo.leadId)
          this.checkPhone()
          if(this.personalinfo.mobileNumber !==null && this.personalinfo.mobileNumber !==""){
            this.checkPhonemobile(this.personalinfo.mobileNumber)
          }
          
          if(this.personalinfo.primaryAddressPostalCode){
            this.personalinfo.primaryAddressPostalCode=this.personalinfo.primaryAddressPostalCode.toUpperCase();
             if(this.personalinfo.primaryAddressPostalCode.length>3){
               this.personalinfo.primaryAddressPostalCode=this.personalinfo.primaryAddressPostalCode.replace(/.{3}$/,' $&');
        
             }
           }
          
           if(this.personalinfo.alternativeAddressPostalCode){
            this.personalinfo.alternativeAddressPostalCode=this.personalinfo.alternativeAddressPostalCode.toUpperCase();
             if(this.personalinfo.alternativeAddressPostalCode.length>3){
               this.personalinfo.alternativeAddressPostalCode=this.personalinfo.alternativeAddressPostalCode.replace(/.{3}$/,' $&');
        
             }
           }
          for (let i = 0; i < this.province.length; i++) {
            this.allPLicensedData.push({ "id": this.province[i].id, "itemName": this.province[i].provinceName +'-'+ this.province[i].provinceCode  });
          }
          if (this.personalinfo.stagesViews != null || undefined) {
            this.showbtn=this.personalinfo.stagesViews[0].isEditable
            if (this.personalinfo.stagesViews[0].isCompleted === true && this.personalinfo.stagesViews[0].isApproved === true) {
              // this.isPersonalInfo = true;
              //this.isCompleted=true;
              this.isdisabledPI = true;
            }
          }

          if (this.personalinfo.languages != null) {
            for (let i = 0; i < this.personalinfo.languages.length; i++) {
              this.languagesArray.push({ "id": this.personalinfo.languages[i], "itemName": this.personalinfo.languages[i] });
            }
          }
          if (this.personalinfo.leadProvinces.length > 0) {
            for (let i = 0; i < this.personalinfo.leadProvinces.length; i++) {
              this.PLicensedArray.push({ "id": this.personalinfo.leadProvinces[i].provinces.id, "itemName": this.personalinfo.leadProvinces[i].provinces.provinceName +'-'+ this.personalinfo.leadProvinces[i].provinces.provinceCode });
            }
          }
          if (this.personalinfo.tags != null) {
            for (let i = 0; i < this.personalinfo.tags.length; i++) {
              this.tagsArray.push({ "id": this.personalinfo.tags[i], "itemName": this.personalinfo.tags[i] });
            }
          }
          if (this.personalinfo.emailAddress != null || undefined) {
            this.emailAddress=[]
            // sessionStorage.setItem("leadEmailInfo", JSON.stringify(this.personalinfo.emailAddress))
            for (var i = 0; i < this.personalinfo.emailAddress.length; i++) {
              var obj = {
                "email": this.personalinfo.emailAddress[i].email,
                "id": this.personalinfo.emailAddress[i].id,
                "isInvalid": this.personalinfo.emailAddress[i].isInvalid,
                "isOptedOut": this.personalinfo.emailAddress[i].isOptedOut,
                "isPrimary": this.personalinfo.emailAddress[i].isPrimary,
              }
              this.emailAddress.push(obj)
              this.isprimarySelected = true;
            }
          }
          if (this.personalinfo.emailAddress == null || undefined) {
            this.addterms(100);
          }


          this.fillData();
          this.dropdownSettings();

          if(this.personalinfo.stagesViews[0].isCompleted === true &&
            this.personalinfo.stagesViews[0].isApproved === true   &&
         this.personalinfo.stagesViews[1].isCompleted === true &&
            this.personalinfo.stagesViews[1].isApproved === true   &&
        this.personalinfo.stagesViews[2].isCompleted === true &&
            this.personalinfo.stagesViews[2].isApproved === true &&
        this.personalinfo.stagesViews[3].isCompleted === true &&
            this.personalinfo.stagesViews[3].isApproved === true)
            {
             this.router.navigate(['/activated']);
       }
        }, error => {

          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;
          }
          else {
            this.error = "Something went wrong. Please check username and password.";
          }
        }, () => { });
  }
  dropdownSettings() {
    this.dropdownSettingsLanguages = {
      singleSelection: false,
      text: "Select Languages",
      selectAllText: 'Select All Languages',
      unSelectAllText: 'UnSelect All Languages',
      enableSearchFilter: true,
      classes: "myclass inputField",
      badgeShowLimit: 15,
      disabled: this.isdisabledPI || this.hideLastRequestedDateSIN
      // disabled: false
    };
    this.dropdownSettingsPLicensed = {
      singleSelection: false,
      text: "Select Province",
      selectAllText: 'Select All Provinces',
      unSelectAllText: 'UnSelect All Provinces',
      enableSearchFilter: true,
      classes: "myclass inputField",
      badgeShowLimit: 15,
      disabled: this.isdisabledPI
     // disabled: false
    };

    this.dropdownSettingsProvinces = { 
      singleSelection: false, 
      text:"Primary Province",
      selectAllText:'Select All Primary Province',
      unSelectAllText:'UnSelect All Primary Province',
      enableSearchFilter: true,
      classes:"myclass custom-class",
      badgeShowLimit: 50,
      disabled: this.isdisabledPI
    };
  }
  agencyCompName:any;
  agencyCompNameId:any;
  fillData() {
    this.firstName = this.personalinfo.firstName;
    this.lastName = this.personalinfo.lastName;
    // this.authservice.userValue.userProfile.firstName=this.userInfo.firstName;
    // this.authservice.userValue.userProfile.lastName=this.userInfo.lastName;
//debugger
    this.middlename = this.personalinfo.middleName
    this.agencyName = this.personalinfo.agencyMgaName;
    this.workPhone = this.personalinfo.workPhone;
    this.phno = this.personalinfo.mobileNumber;
    this.email = this.personalinfo.emailAddress[0].email;
    this.website = this.personalinfo.website;
    this.positionTitle = this.personalinfo.positionTitle;
    this.personalinfo.primaryCompleteAddress = this.personalinfo.primaryCompeteAddress;
    this.primaryAddressCountry = this.personalinfo.primaryAddressCountry;
    this.primaryAddressCity = this.personalinfo.primaryAddressCity;
    this.primaryAddressProvince = this.personalinfo.primaryAddressProvince;
    this.alternativeCompeteAddress = this.personalinfo.alternativeCompeteAddress;
    this.alternativeAddressCountry = this.personalinfo.alternativeAddressCountry;
    this.alternativeAddressCity = this.personalinfo.alternativeAddressCity;
    this.alternativeAddressProvince = this.personalinfo.alternativeAddressProvince;
    if(this.alternativeCompeteAddress || this.alternativeAddressCountry  || this.alternativeAddressCity || this.alternativeAddressProvince != null){
      this.altAddress = false;
      this.altprovince = false;
      this.altcity = false;
      this.altCountry = false;
      this.altPostal = false;
      this.onAlternativeDefault=true;
      }
    this.ciprnumber = this.personalinfo.ciprnumber;
    this.type = this.personalinfo.type;
    this.leadStatus= this.personalinfo.leadStatus;
    this.agencyMgaId = this.personalinfo.agencyMgaId;
    this.userId = this.personalinfo.assignedTo.id;
    
    this.checkComapnyShowStatus = this.personalinfo.commitionTo;
    this.isCompanySignup = this.personalinfo.isCompanyRegister;
    this.companyName = this.personalinfo.companyName;
    this.agencyCompName = this.personalinfo.agencyName;
    this.agencyCompNameId = this.personalinfo.agencyId;
    //this.selectedLanguage=this.personalinfo.languages
    //this.selectedSalutation=this.personalinfo.salutation;
      this.myTravelLinkRequest = this.personalinfo.myTravelLinkRequest
      this.sinNumber=this.personalinfo.socialInsuranceNumber;
      this.confirmSINNumber=this.personalinfo.socialInsuranceNumber;
      // this.BNNumber=this.personalinfo.businessNumber;
      // this.confirmBNNumber=this.personalinfo.businessNumber;

  }
  onPrimaryClicked() {

    Swal.fire("Only First Email Address can be set as Primary!")

  }
  addterms(i) {
    if (i == 100) {
      // this.isprimarySelected =true;
      var obj = {};
      obj["email"] = "";
      obj["id"] = "";
      obj["isInvalid"] = false;
      obj["isOptedOut"] = false;
      obj["isPrimary"] = true;

      this.emailAddress.push(obj);

    }
  }
  addtearms(i, row) {
    // this.addoption=true;

    this.firstBlock = true


    row.error6 = "";
    if (i != 100) {
      if (this.emailAddress[i].email == "") {
        row.error6 = "Email cannot be null!";
        row.error5 == ""
      } else {
        if (this.emailAddress.length > 0) {
          this.isprimarySelected = true;
          this.firstBlock = false;
          i == this.emailAddress.length;
        }
        if (row.error5 == "") {
          var obj = {};
          obj["email"] = "";
          obj["id"] = "";
          obj["isInvalid"] = false;
          obj["isOptedOut"] = false;
          obj["isPrimary"] = false;

          this.emailAddress.push(obj);
        }
      }
    }
  }
  deletetearms(index) {

    this.emailAddress.splice(index, 1);
    this.addoption = false;
    if (this.emailAddress.length == 1) {
      this.firstBlock = true;
    }
    if (index == 0) {
      this.isprimarySelected = false;
    }
  }
  onOptedOutTrue(i) {
    this.optedOut = true;
    this.optedOutNo = i
    this.emailAddress[i].isOptedOut = true
  }
  onOptedOutFalse(i) {
    this.optedOut = false;
    this.optedOutNo = i
    this.emailAddress[i].isOptedOut = false
  }
  InvalidFalse(i) {
    this.Invalid = false;
    this.InvalidNo = i
    this.emailAddress[i].isInvalid = false
  }
  InvalidTrue(i) {
    this.Invalid = true;
    this.InvalidNo = i
    this.emailAddress[i].isInvalid = true
  }
  checkEmail(index, row) {
    this.error6 = "";
    this.user.checkEmail(this.emailAddress[index].email).pipe()
      .subscribe(
        data => {
          if (data.data == "false") {
            row.error3 = null;


          }
          else {
            // this.emailAddress[index].email=null;
            row.error3 = "Entered EmailID Already Exists";
          }
        }, error => {
          //  if(this.baseservice.handleError(error)){
          //handle Exception from Server 404,401
          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;

          }
          else {

            this.error = "Something went wrong";
          }
          //  }
        }, () => { });

  }

  abc(email, row) {
    row.error5 = ""
    row.error6 = ""
    //if(row.error6 !=""){
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(email.toLowerCase())) {
      row.error5 = "Please enter valid Email!"
      //alert("please enter valid email");

      // }
    }
  }
  getLeadTags() {
    this.user.getLeadsTags().pipe()
      .subscribe(
        data => {
          //  this.tagsList = data.data
          if (data.data.length != 0) {
            for (let i = 0; i < data.data.length; i++) {
              this.tagsList.push({ "id": data.data[i].name, "itemName": data.data[i].name });
            }
          }
        }, error => {
          //  if(this.baseservice.handleError(error)){
          //handle Exception from Server 404,401
          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;

          }
          else {

            this.error = "Something went wrong. Please try again later.";
          }

        }, () => { });
  }
  onCIPR(data) {
    this.errorCIPR = ""
    var re = /^[0-9]*$/;
    if (!re.test(data.toLowerCase())) {
      this.errorCIPR = "Alphabets and special symbol are not allowed in CIPR Number!"
    }
  }

  onAlternativeShow(data) {
    this.checkFlag = data.target.checked;
    if (this.checkFlag == true) {
      this.altAddress = false;
      this.altprovince = false;
      this.altcity = false;
      this.altCountry = false;
      this.altPostal = false;
    }

  }
  onAlternativeHide(data) {
    this.checkFlag1 = data.target.checked;
    if (this.checkFlag1 == true) {
      this.altAddress = true;
      this.altprovince = true;
      this.altcity = true;
      this.altCountry = true;
      this.altPostal = true;
      this.personalinfo.alternativeCompeteAddress=null;
      this.personalinfo.alternativeAddressCity=null;
      this.personalinfo.alternativeAddressProvince=null;
this.personalinfo.alternativeAddressPostalCode=null;
    }
  }

  getLeadInfo() {
    this.user.getLeadInfoNew().pipe()
      .subscribe(
        data => {

          this.leadTypes = data.data.leadTypes;

        }, error => {

        }, () => { });

  }
  checkPhone() {
    if (this.personalinfo.workPhone != null) {
      this.user.checkphoneNumber(this.personalinfo.workPhone).pipe()
        .subscribe(
          data => {
            //  console.log(data)
            if (data.data == "false") {
              //this.workPhone=null;
              this.error1 = "Please Enter a Valid  Phone Number";
            }
            else {
              this.error1 = null;
            }
          }, error => {
            //  if(this.baseservice.handleError(error)){
            //handle Exception from Server 404,401
            if (error.status == 400 || error.status == 417) {
              this.error = error.error.data;
            }
            else {
              this.error = "Something went wrong";
            }
            //  }
          }, () => { });
    }
  }
  checkPhonemobile(mobileNumber){

  
if(mobileNumber == ""){
  this.error2=null;
}
    if(mobileNumber.length>0 && mobileNumber.length<10){
      this.error2 = "Please Enter a Valid  Mobile Number";
    }
    else {
      this.error2 = null;
    }
  }
  ip(postalCode){
    //
    this.errorpostalcode=null
    // this.primaryAddressPostalCode
    this.personalinfo.primaryAddressPostalCode=this.personalinfo.primaryAddressPostalCode.toUpperCase()
    // if(postalCode.length>2 && postalCode.length<4){
    //   this.personalinfo.primaryAddressPostalCode=this.personalinfo.primaryAddressPostalCode+" "
    // }
    if(postalCode.length>5){
      this.personalinfo.primaryAddressPostalCode=this.personalinfo.primaryAddressPostalCode.replace(/\s/g, "")
      this.personalinfo.primaryAddressPostalCode=this.personalinfo.primaryAddressPostalCode.replace(/.{3}$/,' $&');
    }
    var re = /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i;
 
    if (!re.test(this.personalinfo.primaryAddressPostalCode)) {
      this.ErrorMsgeleven = true
      this.errorpostalcode="Please enter a valid Postal Code"
    }
    else{
      this.ErrorMsgeleven = false
      this.errorpostalcode=null
    }
  }
  ip1(postalCode1){
      this.errorpostalcodeAlternate=null
    // this.primaryAddressPostalCode
    this.personalinfo.alternativeAddressPostalCode=this.personalinfo.alternativeAddressPostalCode.toUpperCase()

    // if(postalCode1.length>2 && postalCode1.length<4){
    //   this.personalinfo.alternativeAddressPostalCode=this.personalinfo.alternativeAddressPostalCode+" "
    // }
    if(postalCode1.length>5){
      this.personalinfo.alternativeAddressPostalCode=this.personalinfo.alternativeAddressPostalCode.replace(/\s/g, "")
      this.personalinfo.alternativeAddressPostalCode=this.personalinfo.alternativeAddressPostalCode.replace(/.{3}$/,' $&');
    }
    var re = /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i;
 
    if (!re.test(this.personalinfo.alternativeAddressPostalCode)) {
      this.ErrorMsgeleven1 = true
      this.errorpostalcodeAlternate="Please enter a valid Postal Code"
    }
    if(postalCode1.length==0){
      this.ErrorMsgeleven1 = false
      this.errorpostalcodeAlternate=null
    }
  }
  agencyList=[];
  onAgency(){   
    this.user.getmgaAgencyAll().pipe()
    .subscribe(
        data => {
          this.agencyList= data.data;
        },error=>{     
    },()=>{});
  } 
  sinNumber:any=null;
  confirmSINNumber:any=null;
  confirmSINMatch:boolean=false;
  confirmSINMatchlength:boolean=false;
  
checkConfirmSIN(){
////
if(this.sinNumber.length!==9){
  this.confirmSINMatchlength = true;
  this.confirmSINMatch = false;
}
else{
  this.confirmSINMatchlength = false;

  if(this.sinNumber && this.confirmSINNumber){
    if(this.sinNumber==this.confirmSINNumber){
      this.confirmSINMatch = false;
    }else{
      this.confirmSINMatch = true;
      this.confirmSINMatchlength = false;
    }
  }else{
    this.confirmSINMatch = true;
  }
}
  
}
  // checkConfirmBN(){
  //   if(this.BNNumber && this.confirmBNNumber){
  //     if(this.BNNumber==this.confirmBNNumber){
  //       this.confirmBNMatch = false;
  //     }else{
  //       this.confirmBNMatch = true;
  //     }
  //   }
    
  // }
  primaryAddress1c: any;
  showAddressResults1: boolean = false;
  showAddressResults: boolean = false;
  getAddress = [];
  callAddressApiCall() {
      // this.showcheckbox = false
      // this.purchaserAddressSame = false
  
  
      // this.purchaserAddress1Flag=false;
      this.showAddressResults = true;
      // this.purchaseProvince=false;
      // this.purchasePostalCode=false;
      // this.purchaseCity=false;
      this.user.getAddressCanada(this.personalinfo.primaryCompleteAddress).subscribe((data: any) => {
        this.getAddress = data.suggestions;
      }, error => {
        {
          //handle Exception from Server 404,401
        }
      }, () => { });
    }
    callAddressApiCallN() {
      this.showAddressResults = true;
      // this.primaryProvince=false;
      // this.primaryPostalCode=false;
      // this.primaryCity=false;
      this.user.getAddressCanadaN(this.personalinfo.primaryCompleteAddress, this.primaryAddress1c).subscribe((data: any) => {
        this.getAddress = data.Items;
      }, error => {
        {
          //handle Exception from Server 404,401
        }
      }, () => { });
    }
    getSelectedAddress: any[] = [];
    getSelectedAddress1: any[] = [];
    showOutSideProvincePopup: boolean = false;
    ProvinceCode: any;
    onClickSearchResult(item) {
  //
      // if (item.Type == "Address") {
        // this.address1 = item.Text;
        this.showAddressResults = false;
        // this.showcheckbox = true
  
        this.user.getAddressCanadaSelected(item.action.id).subscribe((data: any) => {
          this.getSelectedAddress = data.features;
          this.personalinfo.primaryCompleteAddress =this.getSelectedAddress[0]?.properties?.address_line1;
          // this.address2 = this.getSelectedAddress[0].Line2;
          this.personalinfo.primaryAddressCity = this.getSelectedAddress[0]?.properties?.place;
          this.personalinfo.primaryAddressProvince = this.getSelectedAddress[0]?.properties?.region_code;
          this.personalinfo.primaryAddressPostalCode =this.getSelectedAddress[0]?.properties?.postcode;
          this.ProvinceCode = this.getSelectedAddress[0]?.properties?.region_code;
          this.ErrorMsgeight=false
          this.ErrorMsgprovince=false
          this.errorpostalcode=false
          //     this.purchaseCityFlag=false;
          // this.purchaseProvinceFlag=false;
          // this.purchasePostalCodeFlag=false;
          // this.purchaseCityFlag=false;
          // this.purchasePostalCodeFlag=false;
          // this.purchaseProvinceFlag=false;
        }, error => {
          {
          }
        }, () => { })
      // }
      // else {
      //   this.personalinfo.primaryCompleteAddress = item.Text;
      //   this.primaryAddress1c = item.Id
      //   this.callAddressApiCallN()
      // }
    }
    getAddress1 = [];
  callAddressApiCall1() {
      // this.showcheckbox = false
      // this.purchaserAddressSame = false
  
  
      // this.purchaserAddress1Flag=false;
      this.showAddressResults1 = true;
      // this.purchaseProvince=false;
      // this.purchasePostalCode=false;
      // this.purchaseCity=false;
      this.user.getAddressCanada(this.personalinfo.alternativeCompeteAddress).subscribe((data: any) => {
        this.getAddress1 = data.suggestions;
      }, error => {
        {
          //handle Exception from Server 404,401
        }
      }, () => { });
    }
    callAddressApiCall1N() {
      this.showAddressResults1 = true;
      // this.primaryProvince=false;
      // this.primaryPostalCode=false;
      // this.primaryCity=false;
      this.user.getAddressCanadaN(this.personalinfo.alternativeCompeteAddress, this.primaryAddress1c).subscribe((data: any) => {
        this.getAddress1 = data.Items;
      }, error => {
        {
          //handle Exception from Server 404,401
        }
      }, () => { });
    }
    

    showOutSideProvincePopup1: boolean = false;
    ProvinceCode1: any;
    onClickSearchResult1(item) {
  //
      // if (item.Type == "Address") {
        // this.address1 = item.Text;
        this.showAddressResults1 = false;
        // this.showcheckbox = true
  
        this.user.getAddressCanadaSelected(item.action.id).subscribe((data: any) => {
          this.getSelectedAddress1 = data.features;
          this.personalinfo.alternativeCompeteAddress = this.getSelectedAddress1[0]?.properties?.address_line1;
          // this.address2 = this.getSelectedAddress1[0].Line2;
          this.personalinfo.alternativeAddressCity = this.getSelectedAddress1[0]?.properties?.place;
          this.personalinfo.alternativeAddressProvince = this.getSelectedAddress1[0]?.properties?.region_code;
          this.personalinfo.alternativeAddressPostalCode =this.getSelectedAddress1[0]?.properties?.postcode;
          this.ProvinceCode =this.getSelectedAddress1[0]?.properties?.region_code;
          
          //     this.purchaseCityFlag=false;
          // this.purchaseProvinceFlag=false;
          // this.purchasePostalCodeFlag=false;
          // this.purchaseCityFlag=false;
          // this.purchasePostalCodeFlag=false;
          // this.purchaseProvinceFlag=false;
        }, error => {
          {
          }
        }, () => { })
      // }
      // else {
      //   this.personalinfo.alternativeCompeteAddress = item.Text;
      //   this.primaryAddress1c = item.Id
      //   this.callAddressApiCall1N()
      // }
    }
    ErrorMsgeightinput(primaryAddressCity){
      if(primaryAddressCity.length>0){
        this.ErrorMsgeight=null
      }
      else{
        this.ErrorMsgeight=true
      }

    }
    ErrorMsgprovinceinput(primaryAddressProvince){
      if(primaryAddressProvince.length>0){
        this.ErrorMsgprovince=null
      }
      else{
        this.ErrorMsgprovince=true
      }

    }
    ErrorMsgoneinput(firstName){
      if(firstName.length>0){
        this.ErrorMsgone=null
      }
      else{
        this.ErrorMsgone=true
      }

    }
    ErrorMsgtwoinput(lasstname){
      if(lasstname.length>0){
        this.ErrorMsgtwo=null
      }
      else{
        this.ErrorMsgtwo=true
      }

    }
    ErrorMsgfourinput(completeAddress){
      if(completeAddress.length>0){
        this.ErrorMsgfour=null
      }
      else{
        this.ErrorMsgfour=true
      }

    }
    wfg(){
      this.wfgCode=this.wfgCode.toUpperCase()
    }
    requestedSINHistory(leadId){
      this.requestSINHistory=[]
      this.user.getLicenseRequestCall(leadId,'SIN').pipe()
      .subscribe(
          data => {
             
            if(data.data!="Request Not Found."){
              this.hideLastRequestedDateSIN=true
              this.dropdownSettings()
              // sessionStorage.setItem('sinRequested', JSON.stringify(data.data))
              this.requestSINHistory=data.data;
            //   for(let i=0;i<this.requestHistory?.length;i++){
            //   if(this.requestHistory[i].isRequestCompleted==false){
            //     this.hideLastRequestedDate=true;
            //   }
            // }
              this.lastRequestedDateSIN=this.requestSINHistory[0]?.createdAt;
              this.lastRequestedDateSINBy=this.requestSINHistory[0]?.requestedBy;
            }
            if(data.data=="Request Not Found."){
              this.hideLastRequestedDateSIN=false;
            }
          },error=>{
            this.hideLastRequestedDateSIN=false;
              },()=>{});
      }
      addSin(){
        this.user.addUpdateSIN(this.personalinfo.leadId,this.requestSINHistory[0].id,this.sinNumber).pipe()
      .subscribe(
          data => {
              this.hideLastRequestedDateSIN=false
            
            
          },error=>{
              },()=>{});
      }
}
